import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_white_by_id = (id) => {
  return api.post(
    `${ApiEndpointConstants.GETWHITEBYID}`,
    {},
    { params: { id } }
  );
};
